import React, { useState, useEffect } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';

const MetaDataComponent = ({ onBack, folerName, fileName }) => {
    const [metafileName, setMetaFileName] = useState(fileName);
    const [url, setUrl] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        setMetaFileName(fileName);
    }, [fileName]);
    return (
        <MainCard title={`Tất cả tài liệu / Tài liệu trợ lý ${folerName} / Meta data tài liệu ${fileName}`}>
            <Grid item xs={12} sm={6} sx={{ textAlign: 'left' }}>
                <Button variant="outlined" color="secondary" onClick={onBack}>
                    Quay lại
                </Button>
            </Grid>
            <TextField
                label="Tên tài liệu"
                fullWidth
                value={metafileName}
                // onChange={(e) => setMetaFileName(e.target.value)}
                margin="normal"
            />

            <TextField
                label="URL"
                fullWidth
                value={url || 'Không có'}
                // onChange={(e) => setUrl(e.target.value)}
                margin="normal"
            />

            <TextField
                label="Mô tả"
                fullWidth
                multiline
                value={description || 'Không có'}
                // onChange={(e) => setDescription(e.target.value)}
                margin="normal"
            />
        </MainCard>
    );
};

export default MetaDataComponent;
